<template>
    <div>
<!--        <div class="flex flex-row">-->
<!--            <div class="flex flex-row align-items-center mb-2 mr-4">-->
<!--                <div class="flex flex-row w-10rem">-->
<!--                    <div>timeframe</div>-->
<!--                    <div class="ml-1 text-gray-500 cursor-pointer">-->
<!--                        <i class="pi pi-question-circle"-->
<!--                           v-tooltip.bottom="'Таймфрейм, на котором работает бот.'"></i></div>-->
<!--                </div>-->
<!--                <InputText type="text" v-model="value.timeframe" class="w-3rem p-1 mb-1" />-->
<!--            </div>-->
<!--        </div>-->
        <div class="flex flex-row">
            <div class="flex flex-row align-items-center mb-2 mr-4">
                <div class="flex flex-row w-10rem">
                    <div>maxOpenDeals</div>
                    <div class="ml-1 text-gray-500 cursor-pointer">
                    <i class="pi pi-question-circle"
                       v-tooltip.bottom="'Максимальное количество открытых сделок. Новые сделки выше этого значения совершаться не будут. Отредактируйте, если предел достигнут, а деньги, которые вы хотите пустить в оборот, ещё есть.'"></i></div>
                </div>
                <InputText type="text" v-model="value.maxOpenDeals" class="w-3rem p-1 mb-1" />
<!--                <div class="ml-2 px-1 mr-1 cursor-pointer" @click="decrementMaxDeals"><i class="pi pi-minus text-sm"></i></div>-->
<!--                <div class="px-1 mr-1 cursor-pointer" @click="incrementMaxDeals"><i class="pi pi-plus text-sm"></i></div>-->
<!--                <div v-if="countOpenDeals" class="ml-2">openDeals: {{countOpenDeals}}</div>-->
            </div>
            <div class="flex flex-row align-items-center mb-2 mr-4">
                <div class="flex flex-row w-10rem">
                    <div>buyAmountUsd</div>
                    <div class="ml-1 text-gray-500 cursor-pointer">
                        <i class="pi pi-question-circle"
                           v-tooltip.bottom="'Количество USDT, которое бот будет тратить при совершении сделки. Существует минимальное количество, ниже которого Binance не даёт торговать, оно близко к 10'"></i></div>
                </div>
                <InputText type="text" v-model="value.buyAmountUsd" class="w-3rem p-1 mb-1"/>
            </div>
        </div>
        <div class="flex flex-row">

        </div>
        <Divider></Divider>
        <div class="flex flex-row">
            <div class="flex flex-row align-items-center mb-2 mr-4">
                <div class="flex flex-row align-items-center">
                    <InputSwitch v-model="value.useSlowtrendSettings" ></InputSwitch>
                    <div class="ml-2">Свои настройки для каждого тренда</div>
                    <div class="ml-1 text-gray-500 cursor-pointer">
                        <i class="pi pi-question-circle"
                           v-tooltip.bottom="'Применять выборочные настройки, если тренд восходящий, боковой или нисходящий. Данные тренда берутся по индикатору Slowtrend. '"></i></div>
                </div>
            </div>
        </div>
        <div class="flex flex-column" v-if="value.useSlowtrendSettings === true">
            <div class="flex flex-row align-items-center mb-2">
                <div class="w-3rem">up:</div>
                <div class="flex flex-row w-6rem">
                    <div>hllWidth</div>
                    <div class="ml-1 text-gray-500 cursor-pointer">
                        <i class="pi pi-question-circle"
                           v-tooltip.bottom="'Основной сигнал на покупку, разница между максимумом и минимумом цены за небольшой период. Используются данные от HllIndicator.'"></i></div>
                </div>
                <InputText type="text" v-model="value.slowtrendSettings.up.hllWidth" class="w-4rem p-1 mb-1"/>
                <div class="flex flex-row w-9rem ml-4">
                    <div>takeProfit</div>
                    <div class="ml-1 text-gray-500 cursor-pointer">
                        <i class="pi pi-question-circle"
                           v-tooltip.bottom="'Продавать, когда прибыль превысит данную долю. 1.015 равно росту цены на 1.5%'"></i></div>
                </div>
                <InputText type="text" v-model="value.slowtrendSettings.up.takeProfit" class="w-4rem p-1 mb-1"/>
            </div>
            <div class="flex flex-row align-items-center mb-2">
                <div class="w-3rem">side:</div>
                <div class="flex flex-row w-6rem">
                    <div>hllWidth</div>
                    <div class="ml-1 text-gray-500 cursor-pointer">
                        <i class="pi pi-question-circle"
                           v-tooltip.bottom="'Основной сигнал на покупку, разница между максимумом и минимумом цены за небольшой период. Используются данные от HllIndicator.'"></i></div>
                </div>
                <InputText type="text" v-model="value.slowtrendSettings.side.hllWidth" class="w-4rem p-1 mb-1"/>
                <div class="flex flex-row w-9rem ml-4">
                    <div>takeProfit</div>
                    <div class="ml-1 text-gray-500 cursor-pointer">
                        <i class="pi pi-question-circle"
                           v-tooltip.bottom="'Продавать, когда прибыль превысит данную долю. 1.015 равно росту цены на 1.5%'"></i></div>
                </div>
                <InputText type="text" v-model="value.slowtrendSettings.side.takeProfit" class="w-4rem p-1 mb-1"/>
            </div>
            <div class="flex flex-row align-items-center mb-2">
                <div class="w-3rem">down:</div>
                <div class="flex flex-row w-6rem">
                    <div>hllWidth</div>
                    <div class="ml-1 text-gray-500 cursor-pointer">
                        <i class="pi pi-question-circle"
                           v-tooltip.bottom="'Основной сигнал на покупку, разница между максимумом и минимумом цены за небольшой период. Используются данные от HllIndicator.'"></i></div>
                </div>
                <InputText type="text" v-model="value.slowtrendSettings.down.hllWidth" class="w-4rem p-1 mb-1"/>
                <div class="flex flex-row w-9rem ml-4">
                    <div>takeProfit</div>
                    <div class="ml-1 text-gray-500 cursor-pointer">
                        <i class="pi pi-question-circle"
                           v-tooltip.bottom="'Продавать, когда прибыль превысит данную долю. 1.015 равно росту цены на 1.5%'"></i></div>
                </div>
                <InputText type="text" v-model="value.slowtrendSettings.down.takeProfit" class="w-4rem p-1 mb-1"/>
            </div>
        </div>
        <div class="flex flex-row" v-if="value.useSlowtrendSettings === false">
            <div class="flex flex-row align-items-center mb-2 mr-4">
                <div class="flex flex-row w-9rem">
                    <div>hllWidth</div>
                    <div class="ml-1 text-gray-500 cursor-pointer">
                        <i class="pi pi-question-circle"
                           v-tooltip.bottom="'Основной сигнал на покупку, разница между максимумом и минимумом цены за небольшой период. Используются данные от HllIndicator.'"></i></div>
                </div>
                <InputText type="text" v-model="value.hllWidth" class="w-4rem p-1 mb-1"/>
            </div>
            <div class="flex flex-row align-items-center mb-2 mr-4">
                <div class="flex flex-row w-9rem">
                    <div>takeProfit</div>
                    <div class="ml-1 text-gray-500 cursor-pointer">
                        <i class="pi pi-question-circle"
                           v-tooltip.bottom="'Продавать, когда прибыль превысит данную долю. 1.015 равно росту цены на 1.5%'"></i></div>
                </div>
                <InputText type="text" v-model="value.takeProfit" class="w-4rem p-1 mb-1"/>
            </div>
        </div>
        <Divider></Divider>
        <div class="flex flex-row">
            <div class="flex flex-row align-items-center mb-2 mr-4">
                <div class="flex flex-row w-10rem">
                    <div>betweenDeals</div>
                    <div class="ml-1 text-gray-500 cursor-pointer">
                        <i class="pi pi-question-circle"
                           v-tooltip.bottom="'Как часто можно делать покупки - минимальное расстояние в минутах между сделками.'"></i></div>
                </div>
                <InputText type="text" v-model="value.minutesBetweenDeals" class="w-3rem p-1 mb-1"/>
            </div>

        </div>
        <div class="flex flex-row">
            <div class="flex flex-row align-items-center mb-2 mr-4">
                <div class="flex flex-row w-11rem">
                    <div>useBandForBuy</div>
                    <div class="ml-1 text-gray-500 cursor-pointer">
                        <i class="pi pi-question-circle"
                           v-tooltip.bottom="'Использовать BandIndicator для фильтрации сигналов на покупку - разрешать покупать только под нижней границей. Рекомендуется включать.'"></i></div>
                </div>
                <input type="checkbox" v-model="value.useBandForBuy" />
            </div>
            <div class="flex flex-row align-items-center mb-2 mr-4">
                <div class="flex flex-row w-12rem ml-2">
                    <div class="">stopSellOnUpTrend</div>
                    <div class="ml-1 text-gray-500 cursor-pointer">
                        <i class="pi pi-question-circle"
                           v-tooltip.bottom="'Не продавать, если DontSellLong сигнализирует, что тренд восходящий - цена будет выше, скорее всего позже можно будет продать выгоднее. Включать, если на этой монете бывают резкие всплески цены.'"></i></div>
                </div>
                <input class="" type="checkbox" v-model="value.stopSellOnUpTrend" />
            </div>
        </div>
<!--        <div class="flex flex-row">-->
<!--            <div class="flex flex-row align-items-center mb-2 mr-4">-->
<!--                <div class="flex flex-row w-13rem">-->
<!--                    <div>slowtrendUpBandBorder</div>-->
<!--                    <div class="ml-1 text-gray-500 cursor-pointer">-->
<!--                        <i class="pi pi-question-circle"-->
<!--                           v-tooltip.bottom="'При восходящем тренде по Slowtrend индикатору - какую границу Band индикатора использовать для разрешения покупок, верхнюю или нижнюю (как обычно). Upper показывает лучшие результаты на растущем рынке, но обычно предпочтительнее ставить lower.'"></i></div>-->
<!--                </div>-->
<!--                <Dropdown v-model="value.slowtrendUpBandBorder" :options="['upper','lower']" placeholder="" />-->
<!--            </div>-->
<!--        </div>-->


        <Divider :align="'left'">
            Опасные настройки
        </Divider>
        <div class="flex flex-row">
            <div class="flex flex-row align-items-center mb-2 mr-4">
                <div class="flex flex-row w-10rem">
                    <div>stopLoss</div>
                    <div class="ml-1 text-gray-500 cursor-pointer">
                        <i class="pi pi-question-circle"
                           v-tooltip.bottom="'Момент, когда продавать открытую сделку в убыток. 0 - никогда не продавать. 0.97 - продавать, когда курс упадёт на 3% от закупочного'"></i></div>
                </div>
                <InputText type="text" v-model="value.stopLoss" class="w-4rem p-1 mb-1"/>
            </div>
            <div class="flex flex-row align-items-center mb-2 mr-4">
                <div class="flex flex-row w-10rem">
                    <div>maxHoursNoAction</div>
                    <div class="ml-1 text-gray-500 cursor-pointer">
                        <i class="pi pi-question-circle"
                           v-tooltip.bottom="'Если достигнут maxOpenDeals и нет сделок в течении данного количества часов - продавать самую прибыльную сделку, чтобы освободить слоты для сделок и возобновить торговлю. Оптимальные значения, если ставить - от 24 до 72'"></i></div>
                </div>
                <InputText type="text" v-model="value.maxHoursNoAction" class="w-3rem p-1 mb-1"/>
            </div>
        </div>
        <div class="flex flex-row">
            <div class="flex flex-row align-items-center mb-2 mr-4">
                <div class="flex flex-row w-10rem">
                    <div>sellByTimeout</div>
                    <div class="ml-1 text-gray-500 cursor-pointer">
                        <i class="pi pi-question-circle"
                           v-tooltip.bottom="'Максимальное время жизни открытой сделки в минутах. Если за это время сделка не закрывается - она продаётся принудительно, возможно, в убыток. 0 - не продавать сделки по таймауту.'"></i></div>
                </div>
                <InputText type="text" v-model="value.sellByTimeout" class="w-4rem p-1 mb-1"/>
            </div>
        </div>

    </div>
</template>

<script>
import InputNumber from "primevue/inputnumber";
import InputText from "primevue/inputtext";
import Divider from 'primevue/divider';
import Checkbox from 'primevue/checkbox';
import Dropdown from "primevue/dropdown";
import InputSwitch from "primevue/inputswitch";
export default {
    props: {
        value: Object,
        countOpenDeals: Number|null,
    },
    components:{
        InputSwitch,
        Dropdown,
        InputNumber,
        InputText, Divider, Checkbox
    },
    data(){
        return {

        }
    },
    mounted(){

    },
    watch:{
        form(){
            this.$emit("input", this.form);
        }
    },
    methods:{
        incrementMaxDeals(){
            this.value.maxOpenDeals++;
        },
        decrementMaxDeals(){
            this.value.maxOpenDeals--;
            if(this.value.maxOpenDeals < 0){
                this.value.maxOpenDeals = 0;
            }
        }
    }
}
</script>
